export default "__VITE_ASSET__KYNN7_tE__"